'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _strings = require('helpers/strings');

var _utils = require('helpers/utils');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SSTeamMembers = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    addTeamMemberLoading: state.project.addTeamMemberLoading,
    deleteTeamMemberActionData: state.project.deleteTeamMemberActionData,
    deleteTeamMemberLoading: state.project.deleteTeamMemberLoading,
    editTeamMemberActionData: state.project.editTeamMemberActionData,
    editTeamMemberLoading: state.project.editTeamMemberLoading,
    teamMembersList: state.project.teamMembersListData,
    teamMembersListLoading: state.project.teamMembersListLoading,
    usersList: state.project.usersListData
  };
}, (0, _extends3.default)({}, projectActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SSTeamMembers, _Component);

  function SSTeamMembers() {
    (0, _classCallCheck3.default)(this, SSTeamMembers);
    return (0, _possibleConstructorReturn3.default)(this, (SSTeamMembers.__proto__ || (0, _getPrototypeOf2.default)(SSTeamMembers)).apply(this, arguments));
  }

  (0, _createClass3.default)(SSTeamMembers, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          projectId = _props.projectId,
          loadTeamMembers = _props.loadTeamMembers,
          loadUsersList = _props.loadUsersList;

      loadUsersList();
      if (projectId) {
        loadTeamMembers(projectId);
      }
    }
  }, {
    key: 'onSuggestionSelected',
    value: function onSuggestionSelected(e, _ref) {
      var suggestion = _ref.suggestion;

      (0, _utils.stopEvent)(e);
      var _props2 = this.props,
          addTeamMember = _props2.addTeamMember,
          projectId = _props2.projectId;

      return addTeamMember(projectId, suggestion.userId).promise;
    }
  }, {
    key: 'changeRights',
    value: function changeRights(member) {
      var _props3 = this.props,
          editTeamMember = _props3.editTeamMember,
          projectId = _props3.projectId;

      editTeamMember(projectId, member.shareeId, { isLocked: member.isLocked ? 0 : 1 });
    }
  }, {
    key: 'deleteTeamMember',
    value: function deleteTeamMember(member) {
      var _props4 = this.props,
          deleteTeamMember = _props4.deleteTeamMember,
          projectId = _props4.projectId;

      deleteTeamMember(projectId, member.shareeId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props5 = this.props,
          t = _props5.t,
          teamMembersList = _props5.teamMembersList,
          teamMembersListLoading = _props5.teamMembersListLoading,
          deleteTeamMemberLoading = _props5.deleteTeamMemberLoading,
          deleteTeamMemberActionData = _props5.deleteTeamMemberActionData,
          editTeamMemberLoading = _props5.editTeamMemberLoading,
          editTeamMemberActionData = _props5.editTeamMemberActionData,
          addTeamMemberLoading = _props5.addTeamMemberLoading,
          usersList = _props5.usersList,
          projectId = _props5.projectId;

      var showMemberLoader = function showMemberLoader(member) {
        return deleteTeamMemberLoading && deleteTeamMemberActionData.shareeId === member.shareeId || editTeamMemberLoading && editTeamMemberActionData.shareeId === member.shareeId;
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          { className: 'bold' },
          t('Share this Sharespace with other users in your organisation.')
        ),
        _react2.default.createElement(
          'p',
          { className: 'hint small' },
          t('Sharers will be able to use and upload audio and press content of this sharespace. Email address of the recipients will remain private. As a sharespace creator you will have access to all the projects created from this sharespace')
        ),
        _react2.default.createElement(
          'div',
          { className: 'formRow' },
          _react2.default.createElement(
            'div',
            null,
            t('Enter their email there')
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.AutosuggestField, {
              field: 'userEmail',
              onSuggestionSelected: this.onSuggestionSelected,
              items: usersList,
              readOnly: addTeamMemberLoading || !projectId,
              placeholder: t('Type a recipient')
            }),
            addTeamMemberLoading && _react2.default.createElement(_components.Loader, { small: true, mask: true })
          ),
          !projectId && _react2.default.createElement(
            'div',
            { className: 'hint small danger' },
            t('You need to save project before adding recipients')
          )
        ),
        _react2.default.createElement(
          _components.List,
          { className: 'margin-bottom-20' },
          _react2.default.createElement(
            _components.ListItem,
            { fullWidth: true, isTitle: true },
            _react2.default.createElement(
              'div',
              null,
              t('Name')
            ),
            _react2.default.createElement(
              'div',
              null,
              t('Email')
            ),
            _react2.default.createElement(
              'div',
              null,
              t('Rights')
            ),
            _react2.default.createElement('div', null)
          ),
          teamMembersList.map(function (member) {
            return _react2.default.createElement(
              _components.ListItem,
              { fullWidth: true, key: member.shareeId },
              _react2.default.createElement(
                'div',
                null,
                (0, _strings.concat)(' ', member.name, member.surname)
              ),
              _react2.default.createElement(
                'div',
                null,
                member.userEmail
              ),
              _react2.default.createElement(
                'div',
                { className: member.isLocked ? 'colorError' : 'colorSuccess' },
                member.isLocked ? t('Locked') : t('Standard')
              ),
              _react2.default.createElement(
                'div',
                { className: 'moreCell' },
                _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
                    return _this2.teamMembersListPopover.toggle(e, member);
                  } }),
                showMemberLoader(member) && _react2.default.createElement(_components.Loader, { small: true, mask: true })
              )
            );
          })
        ),
        teamMembersListLoading && _react2.default.createElement(_components.Loader, null),
        _react2.default.createElement(
          _components.PopoverMenu,
          { id: 'teamMembersListPopover', ref: function ref(el) {
              return _this2.teamMembersListPopover = el;
            } },
          _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.changeRights(_this2.teamMembersListPopover.data);
              } },
            t('Change rights'),
            _react2.default.createElement('i', { className: 'icon-lock-open' })
          ),
          _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.deleteTeamMember(_this2.teamMembersListPopover.data);
              } },
            t('Delete'),
            _react2.default.createElement('i', { className: 'icon-delete' })
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'colorError' },
            t('Locked mode')
          ),
          ': ',
          t('sharees can\'t modify audio, cover photo or any security settings')
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'colorSuccess' },
            t('Standard mode')
          ),
          ': ',
          t('sharees can modify parameters according to their own privileges')
        )
      );
    }
  }]);
  return SSTeamMembers;
}(_react.Component), _class3.propTypes = {
  addTeamMember: _propTypes2.default.func,
  addTeamMemberLoading: _propTypes2.default.bool,
  deleteTeamMember: _propTypes2.default.func,
  deleteTeamMemberActionData: _propTypes2.default.object,
  deleteTeamMemberLoading: _propTypes2.default.bool,
  editTeamMember: _propTypes2.default.func,
  editTeamMemberActionData: _propTypes2.default.object,
  editTeamMemberLoading: _propTypes2.default.bool,
  loadTeamMembers: _propTypes2.default.func,
  loadUsersList: _propTypes2.default.func,
  projectId: _propTypes2.default.number.isRequired,
  t: _propTypes2.default.func,
  teamMembersList: _propTypes2.default.array,
  teamMembersListLoading: _propTypes2.default.bool,
  usersList: _propTypes2.default.array
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = SSTeamMembers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/TeamMembers/SSTeamMembers.js
// module id = 2051
// module chunks = 1